import classNames from 'classnames'

import { commonIcons } from '@apps-common/config/icons'

const ICON_STYLES = 'text-[1rem]'

// arm
// disarm
// ON
// off
// activation
// schedule
// panic
// restore
// medical
// trouble
// info

export const NotificationIconTypeKeys = {
  arm: 'arm',
  disarm: 'disarm',
  on: 'on',
  off: 'off',
  activation: 'activation',
  schedule: 'schedule',
  panic: 'panic',
  restore: 'restore',
  medical: 'medical',
  trouble: 'trouble',
  info: 'info'
}

const NotificationIcons = [
  {
    key: NotificationIconTypeKeys.arm,
    IconLight: (
      <div className='bg-red-200 text-red-700 p-[7px] rounded-full'>
        <commonIcons.armed className={classNames(ICON_STYLES)} />
      </div>
    ),
    IconDark: (
      <div className='bg-red-700 text-red-200 p-[7px] rounded-full'>
        <commonIcons.armed className={classNames(ICON_STYLES)} />
      </div>
    )
  },
  {
    key: NotificationIconTypeKeys.disarm,
    IconLight: (
      <div className='bg-green-200 text-green-700 p-[7px] rounded-full'>
        <commonIcons.disarmed className={classNames(ICON_STYLES)} />
      </div>
    ),
    IconDark: (
      <div className='bg-green-700 text-green-200 p-[7px] rounded-full'>
        <commonIcons.disarmed className={classNames(ICON_STYLES)} />
      </div>
    )
  },
  {
    key: NotificationIconTypeKeys.on,
    IconLight: (
      <div className='bg-green-200 text-green-700 p-[7px] rounded-full'>
        <commonIcons.controlOn className={classNames(ICON_STYLES)} />
      </div>
    ),
    IconDark: (
      <div className='bg-green-700 text-green-200 p-[7px] rounded-full'>
        <commonIcons.controlOn className={classNames(ICON_STYLES)} />
      </div>
    )
  },
  {
    key: NotificationIconTypeKeys.off,
    IconLight: (
      <div className='bg-red-200 text-red-700 p-[7px] rounded-full'>
        <commonIcons.controlOff className={classNames(ICON_STYLES)} />
      </div>
    ),
    IconDark: (
      <div className='bg-red-700 text-red-200 p-[7px] rounded-full'>
        <commonIcons.controlOff className={classNames(ICON_STYLES)} />
      </div>
    )
  },
  {
    key: NotificationIconTypeKeys.activation,
    IconLight: (
      <div className='bg-red-200 text-red-700 p-[7px] rounded-full'>
        <commonIcons.mmEventActivation className={classNames(ICON_STYLES)} />
      </div>
    ),
    IconDark: (
      <div className='bg-red-700 text-red-200 p-[7px] rounded-full'>
        <commonIcons.mmEventActivation className={classNames(ICON_STYLES)} />
      </div>
    )
  },
  {
    key: NotificationIconTypeKeys.schedule,
    IconLight: (
      <div className='bg-violet-200 text-violet-700 p-[7px] rounded-full'>
        <commonIcons.schedule className={classNames(ICON_STYLES)} />
      </div>
    ),
    IconDark: (
      <div className='bg-violet-700 text-violet-200 p-[7px] rounded-full'>
        <commonIcons.schedule className={classNames(ICON_STYLES)} />
      </div>
    )
  },
  {
    key: NotificationIconTypeKeys.panic,
    IconLight: (
      <div className='bg-indigo-200 text-indigo-700 p-[7px] rounded-full'>
        <commonIcons.mmEventPanic className={classNames(ICON_STYLES)} />
      </div>
    ),
    IconDark: (
      <div className='bg-indigo-700 text-indigo-200 p-[7px] rounded-full'>
        <commonIcons.mmEventPanic className={classNames(ICON_STYLES)} />
      </div>
    )
  },
  {
    key: NotificationIconTypeKeys.restore,
    IconLight: (
      <div className='bg-emerald-200 text-emerald-700 p-[7px] rounded-full'>
        <commonIcons.checkDouble className={classNames(ICON_STYLES)} />
      </div>
    ),
    IconDark: (
      <div className='bg-emerald-700 text-emerald-200 p-[7px] rounded-full'>
        <commonIcons.checkDouble className={classNames(ICON_STYLES)} />
      </div>
    )
  },
  {
    key: NotificationIconTypeKeys.medical,
    IconLight: (
      <div className='bg-rose-200 text-rose-700 p-[7px] rounded-full'>
        <commonIcons.mmEventMedical className={classNames(ICON_STYLES)} />
      </div>
    ),
    IconDark: (
      <div className='bg-rose-700 text-rose-200 p-[7px] rounded-full'>
        <commonIcons.mmEventMedical className={classNames(ICON_STYLES)} />
      </div>
    )
  },
  {
    key: NotificationIconTypeKeys.trouble,
    IconLight: (
      <div className='bg-amber-200 text-amber-700 p-[7px] rounded-full'>
        <commonIcons.mmEventTrouble className={classNames(ICON_STYLES)} />
      </div>
    ),
    IconDark: (
      <div className='bg-amber-700 text-amber-200 p-[7px] rounded-full'>
        <commonIcons.mmEventTrouble className={classNames(ICON_STYLES)} />
      </div>
    )
  },
  {
    key: NotificationIconTypeKeys.info,
    IconLight: (
      <div className='bg-sky-200 text-sky-700 p-[7px] rounded-full'>
        <commonIcons.mmEventInfo className={classNames(ICON_STYLES)} />
      </div>
    ),
    IconDark: (
      <div className='bg-sky-700 text-sky-200 p-[7px] rounded-full'>
        <commonIcons.mmEventInfo className={classNames(ICON_STYLES)} />
      </div>
    )
  }
]

export const notificationIcon = (type: string, isDark: boolean): any => {
  const item = NotificationIcons.find((i) => i.key === type?.toLowerCase())

  if (item) {
    return isDark ? item.IconDark : item.IconLight
  }

  const defaultIcon = NotificationIcons.find((i) => i.key === NotificationIconTypeKeys.info)

  return isDark ? defaultIcon?.IconDark : defaultIcon?.IconLight
}
